const _xs = "0.75rem"
const _sm = "0.875rem"
const _base = "1rem"
const _lg = "1.125rem"
const _xl = "1.25rem"
const _2xl = "1.5rem"
const _3xl = "1.875rem"
const _4xl = "2.25rem"
const _5xl = "3rem"
const _6xl = "4rem"
const _7xl = "5rem"
const _8xl = "6rem"
const _9xl = "7rem"
const _10xl = "8rem"
const config = { "xs": _xs, "sm": _sm, "base": _base, "lg": _lg, "xl": _xl, "2xl": _2xl, "3xl": _3xl, "4xl": _4xl, "5xl": _5xl, "6xl": _6xl, "7xl": _7xl, "8xl": _8xl, "9xl": _9xl, "10xl": _10xl,  }
export { config as default, _xs, _sm, _base, _lg, _xl, _2xl, _3xl, _4xl, _5xl, _6xl, _7xl, _8xl, _9xl, _10xl }